import { FC } from "react";
import NotFoundComponent from "../../components/404";

const NotFound: FC = (): JSX.Element => <NotFoundComponent />;

export default NotFound;
